import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../../data/SiteConfig';
import * as _ from 'lodash';
import styles from './SlabCommission.module.css';
import { getAcl } from '../../../../common/utils/acl-utils';
import { navigate } from 'gatsby';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import {
  getBankUnitListAPI,
  getCommissionFIUnits
} from '../../../../common/constants/api';
import NewSpinner from '../../../../common/components/NewSpinner/NewSpinner';
import { numberFormat } from '../../../../common/constants/NumberFormat';

const CommissionSlabWise = ({ fiUnit, currentUnitSelected }) => {
  const { tableStyle } = styles;

  const [unitVal, setUnitVal] = useState({
    label: 'Select Unit',
    value: ''
  });

  const [zoneList, setZoneList] = useState([]);
  const [commissionLists, setCommissionLists] = useState([]);
  const [page, pageInfo] = useState({ number: 0 });
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(200);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getAcl()?.acl?.can_access_commission) navigate('/app/dashboard');
  }, []);

  const loadZoneList = () => {
    getBankUnitListAPI(fiUnit)
      .then(res => {
        if (res.error) throw new Error(res);
        if (!res?._embedded?.financialUnitDetailDtoList?.length > 0) return;
        setZoneList(
          res?._embedded?.financialUnitDetailDtoList?.map(each => {
            return { label: each?.unitName, value: each?.id };
          })
        );
        setUnitVal({
          label: res?._embedded?.financialUnitDetailDtoList?.[0]?.unitName,
          value: res?._embedded?.financialUnitDetailDtoList?.[0]?.id
        });
      })
      .catch(error => {});
  };

  useEffect(() => {
    loadZoneList();
  }, []);

  const getCommissionLists = () => {
    setLoading(true);
    getCommissionFIUnits(unitVal?.value, pageNumber, rowsPerPage)
      .then(res => {
        pageInfo(res?.page || { number: 0 });
        setCommissionLists(res?._embedded?.commissionDetailDtoList || []);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (!unitVal.value) return;
    getCommissionLists();
  }, [unitVal?.value]);

  useEffect(() => {
    if (!currentUnitSelected?.value) return;
    if (currentUnitSelected?.value == unitVal?.value) getCommissionLists();
    else setUnitVal(currentUnitSelected);
  }, [currentUnitSelected?.value]);
  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="w-full ml-4" style={{ maxWidth: '200px' }}>
        <CommonSelect sort={true}
          name="unit"
          value={unitVal}
          onChange={e => {
            setUnitVal({ label: e.label, value: e.value });
          }}
          onBlur={() => {}}
          options={zoneList}
          dropdownStyle={{
            top: '52px',
            fontSize: '16px'
          }}
          stylesContainer={{
            height: '52px'
          }}
          styleText={{
            fontSize: '14px',
            padding: '0 20px'
          }}
        />
      </div>

      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <div className="widhtMd max-screen flex-1 w-full">
            <div className="bg-white py-4">
              <div
                className="w-full mx-4 relative m-auto overflow-auto"
                style={{
                  width: '98%'
                }}
              >
                <React.Fragment>
                  <div
                    className="py-4 px-4 border rounded-lg mb-4"
                    style={{
                      borderColor: '#E7F0FC',
                      borderWidth: '2px',
                      minWidth: 'fit-content'
                    }}
                  >
                    <div className="lg:flex mb-3">
                      <div>
                        <p className="text-left text-base font-khand text-black-600 py-1 font-bold text-base">
                          Slab Lists
                        </p>
                      </div>
                      <div className="lg:ml-auto lg:flex">
                        <div
                          style={{
                            backgroundColor: '#00ACB81C',
                            maxHeight: '30px',
                            width: 'fit-content'
                          }}
                          className="py-1 lg:mx-2"
                        >
                          <p
                            className="text-tealCol-100 px-2"
                            style={{ minWidth: '70px' }}
                          >
                            {unitVal?.label}
                          </p>
                        </div>
                      </div>
                    </div>
                    <table className={`w-full  ${tableStyle}`}>
                      <thead>
                        <tr className="text-sm">
                          <th className=" px-4 py-4">SL No</th>
                          <th className=" px-2 py-2">Slab Range (cr)</th>
                          <th className=" px-2 py-2">Commission %</th>
                          <th className=" px-2 py-2">Product Group </th>
                          <th className=" px-2 py-2">Product </th>
                          <th className=" px-2 py-2 text-right ">
                            Max Cap (in &#8377;)
                          </th>
                        </tr>
                      </thead>
                      {loading || commissionLists.length == 0 ? (
                        <tbody>
                          <tr className="w-full text-center">
                            <td colSpan="5">
                              <div className="table mx-auto">
                                {loading && <NewSpinner />}
                              </div>
                              {commissionLists.length == 0 && !loading && (
                                <p>No data!</p>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody className="">
                          {commissionLists.map((each, i) => {
                            const {
                              commissionPercentage,
                              maxAmount,
                              minAmount,
                              productGroupId,
                              productGroupName,
                              productId,
                              productName,
                              maxCapping
                            } = each;
                            return (
                              <tr
                                key={i}
                                className="hover:bg-grey-1009 font-roboto font-normal text-xs text-black-850"
                              >
                                <td className="px-4 py-4">
                                  {page?.size * pageNumber + (i + 1)}
                                </td>
                                <td className="px-2 py-4">
                                  <div
                                    className="flex range"
                                    style={{ maxHeight: '30px' }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: '#DDEBFC',
                                        width: '120px',
                                        padding: '7px'
                                      }}
                                      className="mr-2"
                                    >
                                      {minAmount / 10000000}
                                    </div>
                                    <hr
                                      style={{
                                        border: '1px solid #C7D9F0',
                                        minWidth: '30px',
                                        margin: '15px 0px '
                                      }}
                                    />
                                    <div
                                      style={{
                                        backgroundColor: '#DDEBFC',
                                        padding: '7px',
                                        width: '120px'
                                      }}
                                      className="ml-2"
                                    >
                                      {parseFloat(maxAmount / 10000000)}
                                    </div>
                                  </div>
                                </td>
                                <td className="px-2 py-4">
                                  {commissionPercentage}
                                </td>
                                <td className="px-2 py-4">
                                  {productGroupName || '---'}
                                </td>
                                <td className="px-2 py-4">
                                  {productName || '---'}
                                </td>

                                <td className="px-2 py-4 ">
                                  {maxCapping ? (
                                    <span>
                                      &#8377; {numberFormat(maxCapping)}
                                    </span>
                                  ) : (
                                    '----'
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      )}
                    </table>
                  </div>
                </React.Fragment>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CommissionSlabWise;
